import type { PostPermissionAssignmentPayload } from "@onhandtech/onhand-fe-shared/lib/contracts/api/common/permission-assignments";
import { createReduxServiceModule } from "@onhandtech/onhand-fe-shared/lib/redux";
import type { RequestArgs } from "@onhandtech/onhand-fe-shared/lib/request";
import { createRequestError } from "@onhandtech/onhand-fe-shared/lib/request";
import type { AxiosError } from "axios";

export const moduleName = "delete-campaign-permissions";

const args: RequestArgs<
	null,
	true,
	never,
	PostPermissionAssignmentPayload<"campaign_id">
> = {
	method: "DELETE",
	url: "",
	handleSuccess: () => true,
	handleFailure: (error: AxiosError) => createRequestError(error, moduleName),
};

const deleteCampaignPermissionAssignmentsModule = () =>
	createReduxServiceModule<
		null,
		true,
		never,
		PostPermissionAssignmentPayload<"campaign_id">
	>({ moduleName, args });

export default deleteCampaignPermissionAssignmentsModule;
